// Perf fix (2026-05-17): Defer Swiper init until after window.load + idle.
// Original behavior: mountSlider() ran in constructor → Swiper repositioned
// slides before LCP element painted, costing ~2s element-render-delay.
// New behavior: First slide renders statically (Swiper not yet active),
// Swiper takes over after page is fully loaded via requestIdleCallback.
if(!customElements.get('hero-slider')) {
  class HeroSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', () => this.mountSlider());
        this.mountSlider();
        return;
      }

      const init = () => {
        if (typeof Swiper === 'undefined' || this.slider) return;
        this.mountSlider();
      };

      const scheduleInit = () => {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(init, { timeout: 2000 });
        } else {
          setTimeout(init, 1);
        }
      };

      if (document.readyState === 'complete') {
        scheduleInit();
      } else {
        window.addEventListener('load', scheduleInit, { once: true });
      }

      window.addEventListener('shopify:block:select', e => {
        if (!this.slider) return;
        const selectedSlideIndex = +e.target.dataset.index;
        this.slider.slideTo(selectedSlideIndex, 600);
      });
    }

    mountSlider() {
      const autoplayOptions = {
        delay: this.dataset.autoplayInterval
      };

      this.slider = new Swiper(this, {
        effect: 'fade',
        rewind: true,
        slidesPerView: 1,
        speed: 600,
        followFinger: false,
        navigation: {
          nextEl: '.swiper-button--next',
          prevEl: '.swiper-button--prev'
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet: function (i, className) {
            return `
            <button class="${className}">
              <span>0${i + 1}</span>
              <svg class="square-progress" width="26" height="26">
                <rect class="square-origin" width="26" height="26" rx="5" ry="5" />
              </svg>
              <svg class="progress" width="18" height="18" style="inset-inline-start: ${0 - ((i * 2.4) + 3.4)}rem">
                <circle class="circle-origin" r="8" cx="9.5" cy="9.5"></circle>
              </svg>
            </button>
            `;
          }
        },
        autoplay:
          this.dataset.autoplay === 'true' ? autoplayOptions : false,
        on: {
          init: this.handleSlideChange.bind(this),
          slideChange: this.handleSlideChange.bind(this)
        }
      });
    }

    handleSlideChange(swiper) {
      let headerInner = document.querySelector('.header__inner');
      let heroInners = document.querySelectorAll('.hero__inner');

      if (!headerInner || !heroInners) {
        return;
      }

      // change --transparent-header-menu-text-color value on document style attributes
      document.documentElement.style.setProperty(
        '--transparent-header-menu-text-color',
        heroInners[swiper.activeIndex].dataset.headerMenuTextColor
      );
    }
  }
  customElements.define('hero-slider', HeroSlider);
}
